import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, Form } from "react-bootstrap";
import { TelephoneFill } from "react-bootstrap-icons";
import { motion } from "framer-motion";

const ContactRow = () => {

  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    treatment: "",
    date: ""
  });

  const [loading, setLoading] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    setLoading(true);

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxQzpZpKCzBeBuAju8jsOCXFuThomZFdh8-Yx_IELE1omgw23KXNteOrt7qVSubU3hmqw/exec";

    try {

      const response = await fetch(scriptURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          action: "new",   // 🔥 FIX (most important)
          ...formData
        }),
      });

      const data = await response.json();

      if (data.status === "saved") {
        alert("Appointment Booked Successfully!");
      } else {
        alert("Something went wrong");
      }

      setShowModal(false);

      setFormData({
        name: "",
        mobile: "",
        treatment: "",
        date: "",
      });

    } catch (error) {
      console.log(error);
      alert("Server Error");
    }

    setLoading(false);
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{ backgroundColor: "#9c6926", color: "white", padding: "50px 0" }}
      >
        <Container fluid>
          <Row className="align-items-center justify-content-between text-center text-md-start mx-0">

            <Col xs={12} md={4} className="d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0 px-2">
              <motion.a
                href="tel:+919511291664"
                whileHover={{ scale: 1.2 }}
                style={{ color: "white", display: "flex", alignItems: "center" }}
              >
                <TelephoneFill size={50} />
              </motion.a>

              <div className="ms-2">
                <small style={{ opacity: "0.8" }}>Contact Us</small>
                <strong style={{ fontSize: "18px", display: "block" }}>
                  +91 9511291664
                </strong>
              </div>
            </Col>

            <Col xs={12} md={4} className="text-center mb-3 mb-md-0">
              <h5 style={{ fontWeight: "600" }}>
                SCHEDULE YOUR CONSULTATION
              </h5>
            </Col>

            <Col xs={12} md={4} className="text-center text-md-end">
              <Button variant="light" onClick={handleShow}>
                BOOK AN APPOINTMENT
              </Button>
            </Col>

          </Row>
        </Container>
      </motion.div>

      {/* Modal */}

      <Modal show={showModal} onHide={handleClose} centered>

        <Modal.Header closeButton>
          <Modal.Title>Book Appointment</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <Form onSubmit={handleSubmit}>

            <Form.Control
              className="mb-3"
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <Form.Control
              className="mb-3"
              type="tel"
              name="mobile"
              placeholder="Mobile"
              value={formData.mobile}
              onChange={handleChange}
              required
            />

            <Form.Select
              className="mb-3"
              name="treatment"
              value={formData.treatment}
              onChange={handleChange}
              required
            >
              <option value="">Select Treatment</option>
              <option>Skin Treatment</option>
              <option>Hair Treatment</option>
              <option>Laser Treatment</option>
              <option>Acne Treatment</option>
            </Form.Select>

            <Form.Control
              className="mb-3"
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />

            <Button type="submit" variant="dark" className="w-100" disabled={loading}>
              {loading ? "Booking..." : "Book Appointment"}
            </Button>

          </Form>

        </Modal.Body>

      </Modal>
    </>
  );
};

export default ContactRow;